@if(authService.isLoggedIn()) {
<app-header></app-header>
}
<div class="main-layout" [ngClass]="{ 'logged-out': !authService.isLoggedIn() }">
  @if(authService.isLoggedIn()) {
  <app-sidemenu></app-sidemenu>
  }
  <section class="mainwrapper">
    <app-loader></app-loader>
    <app-password-prompt></app-password-prompt>
    <app-feature-tabs></app-feature-tabs>
    <router-outlet />
  </section>
</div>